// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Usuarios_TogglefranquiausuarioResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /usuarios/toggleFranquiaUsuario
 *
 * Returns success flag after toggling franchise access for a user.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Usuarios_TogglefranquiausuarioResponseDados = boolean;

export type Usuarios_TogglefranquiausuarioResponse = ApiResponse<Usuarios_TogglefranquiausuarioResponseDados>;

registerResponseContract('Usuarios_TogglefranquiausuarioResponse', {})
